const Config = {
  zamnaWebSiteInLanguage: (lang: string) =>
    `https://www.zamna.com/?lang=${lang}`,
};

export default Config;
